import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { Cell } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/Cell';
import './index.scss';
import { IDateCellProps } from './type';
import classNames from 'classnames';
import moment from 'moment';

const WEEKDAY_I18N_KEYS = [
  'common_mon',
  'common_tues',
  'common_wed',
  'common_thur',
  'common_fri',
  'common_sat',
  'common_sun',
];

export const DateCell = (props: IDateCellProps) => {
  const { className, style, value = '', record = {}, config } = props;
  const {
    tagKey = '',
    tagColor = '#6A96F5',
    tagColorMap,
    inputFormat = 'YYYYMMDD',
    outputFormat = 'YYYY-MM-DD',
    showWeekday,
    weekdayColor = '#B0B4BE',
    weekendColor = '#6A96F5',
  } = config || {};
  const { formatMessage } = useIntl();

  const parsed = useMemo(() => moment(value, inputFormat), [value, inputFormat]);
  const formattedDate = (parsed.isValid() ? parsed.format(outputFormat) : value) || '-';

  const weekdayTag = useMemo(() => {
    if (!showWeekday || !parsed.isValid()) return null;
    const isoDay = parsed.isoWeekday();
    const label = formatMessage({ id: WEEKDAY_I18N_KEYS[isoDay - 1] });
    const isWeekend = isoDay === 6 || isoDay === 7;
    return { label, color: isWeekend ? weekendColor : weekdayColor };
  }, [showWeekday, parsed, formatMessage, weekendColor, weekdayColor]);

  const legacyTag = useMemo(() => {
    if (showWeekday) return null;
    const tagValue = record?.[tagKey];
    if (!tagValue) return null;
    const color = (tagColorMap && tagValue)
      ? (tagColorMap[tagValue] ?? tagColorMap._default ?? tagColor)
      : tagColor;
    return { label: tagValue, color };
  }, [showWeekday, record, tagKey, tagColorMap, tagColor]);

  const tag = weekdayTag || legacyTag;

  return (
    <Cell className={classNames('dbd-common-table__date-cell', className)} style={style}>
      <div className="dbd-common-table__date-cell-date">{formattedDate}</div>
      {tag && <div className="dbd-common-table__date-cell-tag" style={{ color: tag.color }}>{tag.label}</div>}
    </Cell>
  );
};
